import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Steampunk tipkovnica",
  "description": "",
  "published": "2007-02-28T00:00:00.000Z",
  "redirect_from": ["/blog/steampunk-tipkovnica/swizec/276"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vedno sem vedel, da mi je ta stil zelo vsec, sedaj pa celo vem, da se imenuje steampunk. Morate priznati, da je hudicevo dober stil. Kakorkoli, `}<a parentName="p" {...{
        "href": "http://steampunkworkshop.com/keyboard.shtml"
      }}>{`tu`}</a>{` je zanimiva steampunk tipkovnica in ce kdajkoli dobim kaj takega v roke bom lahko umrl srecen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      